import PropTypes from 'prop-types';
import React from 'react';

import BadgeActiveTimeRange from 'src/components/Badge/BadgeActiveTimeRange';
import Loading from 'src/components/Loading';
import UUID from 'src/components/UUID';

/**
 * Description
 * @param {object} props
 * @returns {React.ReactComponentElement} - AdminMeterShowTariff component
 */
function AdminMeterShowTariff(props) {
  if (!props) {
    return <tr><td aria-label="loading" colSpan={4}><Loading /></td></tr>;
  }

  const { tariff } = props;
  const {
    id, identifier, active, meter,
  } = tariff;
  const { id: meterId } = meter;

  return (
    <tr key={`tariff-${id}`}>
      <th scope="row" className="text-right">
        <UUID uuid={id} url={`/admin/tariffs/${id}`} />
      </th>
      <td>{identifier}</td>
      <td>
        <BadgeActiveTimeRange active={active} />
      </td>
      <td>
        <UUID uuid={meterId} />
      </td>
    </tr>
  );
}

AdminMeterShowTariff.propTypes = {
  tariff: PropTypes.shape({
    id: PropTypes.string,
    identifier: PropTypes.string,
    active: PropTypes.shape({
      start: PropTypes.number,
      finish: PropTypes.number,
    }),
    meter: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
};

AdminMeterShowTariff.defaultProps = {
  tariff: null,
};

export default AdminMeterShowTariff;
